/****************************************************
 * Module Name:  reprintBarcode.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box, Button, TextField } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import Constants from "../../utility/constants";
import "./../../style/modalstyle.css";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import PacketHistoryModal from "../common/packetHistoryModal";
import { LoadingButton } from "@mui/lab";
import PrintBarcode from "./printBarcode";
import { FaBarcode } from "react-icons/fa";
import NoPermission from "../common/noPermission";
import { useEffect } from "react";
import SaveIcon from '@mui/icons-material/Save';
import PacketProxy from "../../utility/proxy/manager/manufacturingProxy/packetProxy";
import PageTitle from "../common/pageTitle";

const ReprintBarcode = () => {
    // eslint-disable-next-line
    const [data, setData] = useState([]);
    const [arr, setarr] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState([]);
    const [alertSnackbar, setAlertSnackbar] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [packetId, setPacketId] = useState("");
    const [kapanId, setKapanId] = useState("");
    const [showPacketDetailModal, setShowPacketDetailModal] = useState(false);
    const [showError, setShowError] = useState(false);
    const [barcodeModal, setBarcodeModal] = useState(false);
    const [access, setAccess] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);


    useEffect(() => {
        PageTitle("MANUFACTURING_OPERATION_REPRINTBARCODE");
        checkPermission();
    }, []);

    const checkPermission = () => {
        let allowed = Constants.USER_PERMISSION.find(
            (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.MANUFACTURING_OPERATION_REPRINTBARCODE
        ) !== undefined
        if (!allowed) {
            setAccess(true)
            return <NoPermission />
        }
    }

    const prepareData = (array) => {
        if (!array.length || !Array.isArray(array)) return;
        let arr = [];
        array.forEach((item) => {
            let filteredArr = data.find((lData) => lData.packetid === item.packetid);
            let obj = {
                ...item,
                createdat: filteredArr.createdat,
                kapanid: data[0].kapanid,
                createdfrompacket: undefined,
                userid: Constants.loggedInUser.id,
                updatedat: Utility.ConvertLocalTimeToUtc(new Date()).slice(0, 11) +
                    "00:00:00.000Z",
            };
            arr.push(obj);
        });
        return arr;
    };

    const handleCreateLot = () => {
        let data = prepareData(selectedRowData)
        setLoadingButton(true)
        // Creating new issue, and once issue is created on call refresh the list of current issue
        PacketProxy.AddPackageDetail(data, (response) => {
            if (response) {
                setData([])
                setKapanId("")
                setPacketId("")
                setLoadingButton(false)
            } else {
                setShowError(true)
                setLoadingButton(false)
            }
        });
    };

    const handleSearch = () => {
        if (packetId.length === 0 || kapanId.length === 0) {
            return true;
        }
        setLoadingButton(true)
        PacketProxy.GetSingleFurtherPackets(kapanId, packetId, (response) => {
            if (response) {
                setData(response)
                setLoadingButton(false)
            } else {
                setShowError(true)
                setLoadingButton(false)
            }
        })
    }

    const columnName = [
        {
            field: "createdat",
            headerName: "CREATED AT",
            headerAlign: "center",
            align: "center",
            minWidth: 150,
            flex: 1,
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        },
        {
            field: "packetid",
            headerName: "PACKETID",
            headerAlign: "center",
            align: "center",
            width: 80,
            renderCell: (params) => (Utility.NeedToShowPacketDetailModal()) ?
                <Button
                    sx={{
                        textDecorationLine: "underline",
                        color: 'black'
                    }}
                    onClick={() => handlePacketDetailModal(params.value, params.row.kapanid)}
                >
                    {params.value}
                </Button>
                :
                <div>{params.value}</div>,
        },
        {
            field: "editweight",
            headerName: "ENTER WEIGHT",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            minWidth: 50,
            flex: 0.5,
            editable: true,
            hideable: false,
            preProcessEditCellProps: (params) => {
                const hasError = parseFloat(params.props.value) <= 0
                setShowError(hasError ? true : false);
                setAlertMessage("Weight cannot be 0");
                return { ...params.props, error: hasError };
            },
        },
        {
            field: "editprice",
            headerName: "ENTER PPC",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            minWidth: 50,
            flex: 0.5,
            editable: true,
            hideable: false,
            preProcessEditCellProps: (params) => {
                const hasError = parseFloat(params.props.value) <= 0;
                setShowError(hasError ? true : false);
                setAlertMessage("Price cannot be 0");
                return { ...params.props, error: hasError };
            },
        },
    ];

    const handlePacketDetailModal = (params, kapanid) => {
        setPacketId(params);
        setKapanId(kapanid);
        setShowPacketDetailModal(true);
    };

    const close = () => {
        setShowPacketDetailModal(false)
    }

    const onCellEditCommit = (cellData) => {
        const { id, field, value } = cellData;

        let rowData = selectedRowData;
        if (rowData.find((obj) => obj.packetid === id)) {
            if (Utility.CheckisNumberGreaterThanZero(value)) {
                let trowData = rowData.find((item) => item.packetid === id);
                trowData[field === "editweight" ? 'weight' : 'price'] = value;
                setarr([...arr, 1])
            }
        } else if (Utility.CheckisNumberGreaterThanZero(value)) {
            rowData.push({
                packetid: id,
                [field === "editweight" ? "weight" : "price"]: value,
            });
            setarr([...arr, 1])
        }
        setSelectedRowData(rowData);
    };
    const rows = data;
    const columns = columnName;
    return (
        <div>
            {showPacketDetailModal ? (
                <PacketHistoryModal
                    show={showPacketDetailModal}
                    packetId={packetId}
                    kapanId={kapanId}
                    close={close}
                />
            ) : null}
            <CommonSnackbar
                show={showError}
                message={
                    <Box>
                        Get Data Failed
                        <br /> Please enter correct data
                    </Box>
                }
                variant={"error"}
                autoHide={false}
                handleClose={() => setShowError(false)}
                title="Validation Failure"
            />
            <CommonSnackbar
                show={alertSnackbar}
                message={alertMessage}
                variant={"error"}
                autoHide={false}
                title={"Error"}
                handleClose={() => setAlertSnackbar(false)}
            />
            {
                access ? <NoPermission /> : (
                    <Box>
                        {barcodeModal ?
                            (
                                <div id="barcodeData" name="barcodeData" style={{ display: "none" }}>
                                    <PrintBarcode
                                        Show={true}
                                        handleClose={() => setBarcodeModal(false)}
                                        sourceData={data}
                                    />
                                </div>
                            ) : (
                                <Box />
                            )}
                        <Box px={1}>
                            <Box style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between' }}>

                                <Box style={{ display: 'flex', justifyContent: 'space-between', width: '50%', marginLeft: 10 }}>
                                    <TextField
                                        className="picker"
                                        margin="normal"
                                        label="Kapan Id"
                                        placeholder="Enter Kapan Id"
                                        value={kapanId}
                                        onChange={(e) =>
                                            setKapanId(e.target.value)
                                        }
                                    />
                                    <TextField
                                        className="picker"
                                        margin="normal"
                                        label="Packet Id"
                                        placeholder="Enter PacketId"
                                        value={packetId}
                                        onChange={(e) =>
                                            setPacketId(e.target.value)
                                        }
                                    />
                                    <LoadingButton
                                        loading={loadingButton}
                                        loadingPosition="start"
                                        variant="contained"
                                        size="large"
                                        onClick={() => handleSearch()}
                                        startIcon={<SearchOutlinedIcon size="large" />}
                                        sx={{ mt: 1, alignSelf: "center", ml: 2 }}
                                    >
                                        Search
                                    </LoadingButton>
                                </Box>
                                <Box
                                    style={{
                                        textAlign: "right",
                                        marginTop: "0.5rem",
                                        width: "100%",
                                        marginRight: 4
                                    }}
                                >
                                    <Button variant="contained"
                                        disabled={data.length === 0}
                                        startIcon={<FaBarcode size="15px" />}
                                        onClick={() => {
                                            setBarcodeModal(true); setTimeout(() => {
                                                var newWindow = window.open();
                                                var content = document.getElementById("barcodeData");
                                                newWindow.document.write(content.innerHTML);
                                                newWindow.print();
                                            }, 500);
                                        }}
                                        sx={{ m: "15px" }}>
                                        Print
                                    </Button>
                                </Box>
                            </Box>
                            <Box
                                sx={{
                                    backgroundColor: '#fff',
                                    color: '#000',
                                    width: "100%",
                                    position: "relative",
                                    "& .MuiTablePagination-selectLabel": {
                                        marginTop: "15px",
                                    },
                                    "& .MuiTablePagination-displayedRows": {
                                        marginTop: "15px",
                                    },
                                    "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                        fontWeight: Constants.defaultFontWeight,
                                    },
                                    "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                                        color: "#1976d2",
                                        padding: "4px 5px",
                                        borderRadius: "4px",
                                    },
                                    "& .css-cc8tf1": {
                                        fontWeight: Constants.defaultFontWeight,
                                    },
                                    "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
                                        color: "#1976d2",
                                        padding: "5px 5px",
                                        borderRadius: "4px",
                                    },
                                    height: "80vh",

                                }}
                            >
                                <DataGrid
                                    disableSelectionOnClick={true}
                                    getRowHeight={() => "auto"}
                                    sx={{
                                        '& .MuiDataGrid-columnHeader': {
                                            color: '#fff',
                                            backgroundColor: 'grey',
                                        },
                                        "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                            py: "4px",
                                        },
                                        "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                            py: "12px",
                                        },
                                        "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                            py: "18px",
                                        },

                                        fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                                    }}
                                    loading={loadingButton}
                                    density="compact"
                                    onCellEditCommit={onCellEditCommit}
                                    components={{ Toolbar: GridToolbar }}
                                    rows={rows}
                                    columns={columns}
                                    getRowId={(row) => row.packetid}
                                    initialState={{
                                        columns: {
                                            columnVisibilityModel: {
                                                // Hide columns id, the other columns will remain visible
                                                createdat: false
                                            },
                                        },
                                        sorting: {
                                            sortModel: [{ field: "packetid", sort: "asc" }],
                                        },
                                        pagination: {
                                            paginationModel: Constants.pageSize,
                                        },
                                    }}
                                    pageSizeOptions={Constants.pageSizeOptions}
                                    pagination
                                    componentsProps={{
                                        toolbar: {
                                            showQuickFilter: true,
                                            quickFilterProps: { debounceMs: 500 },
                                        },
                                    }}
                                />
                                <Box style={{ position: "absolute", top: 5, right: "270px" }}>
                                    <LoadingButton
                                        loading={loadingButton}
                                        loadingPosition="start"
                                        startIcon={<SaveIcon />}
                                        color="info"
                                        variant="outlined"
                                        size="small"
                                        component="label"
                                        sx={{ mr: "15px" }}
                                        disabled={(arr.length >= (data.length * 2)) && data.length !== 0 ? false : true}
                                        onClick={handleCreateLot}
                                    >
                                        Save
                                    </LoadingButton>

                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )
            }
        </div>
    );
};

export default ReprintBarcode;
